var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoodDiaryNewEntry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}.cls-2{fill:#ff75b0;}.cls-3{fill:#fce3f1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.86,
    y: 1.11,
    width: 600,
    height: 600
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.86,
    y: 1.11,
    width: 600,
    height: 600
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "food_diary_new_entry"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 300.66,
    cy: 299.92,
    r: 300
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M448,244.46H357.71V159.29a56.2,56.2,0,0,0-56-56h0a56.2,56.2,0,0,0-56,56v85.17H165.48a56.19,56.19,0,0,0-56,56h0a56.19,56.19,0,0,0,56,56h80.17v85.27a56.19,56.19,0,0,0,56,56h0a56.19,56.19,0,0,0,56-56V356.52H448a56.2,56.2,0,0,0,56-56h0A56.2,56.2,0,0,0,448,244.46Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodDiaryNewEntry);
export default __webpack_public_path__ + "static/media/food_diary_new_entry.b543b71179e9f0247602727b249f418e.svg";
export { ForwardRef as ReactComponent };